export const colors = {
  white: "#FFFFFF",
  whisperWhite: "#FBFBFD",
  highlight: "#E6F2FC",
  primary: "#FC8F49",
  secondary: "#00B5F6",
  textBackground: "#4EB4F0",
  info: "#B4B4B4",
  border: "#C4C4C4",
  selected: "#55C37D",
  background: "#5C626A",
  backgroundLight: "#9DA1A5",
  backgroundLight2: "#979B9F",
  black: "#000000",
  red: "red",
};
